import { webClipboard } from './web'
import type { HostLike, PlatformCapabilities } from './types'

/**
 * macOS 壳（Tauri v2）那一档的实现。
 *
 * # 剪贴板为什么就是 WebView 那一个
 *
 * 不是偷懒，是事实：Tauri v2 的 WebView 从 `tauri://localhost` 加载，
 * 那是一个**安全上下文**，`navigator.clipboard` 在里面可用，而且写进去的
 * 就是系统剪贴板。再包一层 Rust command 不会让它更真。
 *
 * 而且原生那条路今天**根本不存在**：`apps/desktop/src-tauri/capabilities/default.json`
 * 只放开了 `core:default`、`dialog:allow-open`、`notification:default`——
 * 没有 `clipboard-manager`。写一个 `invoke('plugin:clipboard-manager|write_text')`
 * 会在客户端里当场被权限挡下，而它挡下的样子是一个 rejected promise，
 * 归到 `failed`——**用户会看到「再点一次」，然后点一辈子**。
 *
 * 所以这里如实委托给 WebView 的实现。哪天真给壳加了 clipboard 插件，
 * 改的是这一个函数，八处调用方一行都不用动——这正是这个接缝的意义。
 *
 * # 为什么还是要有这个函数
 *
 * 因为「macOS 上剪贴板与 Web 走同一条路」是一句**会过期的话**。
 * 把它写成一行代码，改的时候编译器看得见；写成注释的话，
 * 下一个人只会读到「这里和 Web 一样」，然后在别处再写一个 if。
 */
export function macosCapabilities(host: HostLike): PlatformCapabilities {
  return { surface: 'macos', clipboard: webClipboard(host) }
}
